import axios from 'axios'
import { API_BASE_URL } from 'src/configs/AppConfig'
import history from 'src/history'

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000
})

// Config
const ENTRY_ROUTE = '/auth/login'
const TOKEN_PAYLOAD_KEY = 'authorization'
const PUBLIC_REQUEST_KEY = 'public-request'

// API Request interceptor
service.interceptors.request.use((config: any) => {
	const jwtToken = localStorage.getItem("accessToken")
	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken
	}

	if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
			history.push(ENTRY_ROUTE)
			window.location.reload();
	}
	config.params = {...config.params, system: 1}
	return config
}, error => {
	// Do something with request error here
	// notification.error({
	// 	message: 'Error'
	// })
  Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		message: '',
        description: ''
	}
	console.error(error);
	// Remove token and redirect 
	if (error.response.status === 401 || error.response.status === 403) {
		notificationParam.message = 'Authentication Fail'
		notificationParam.description = 'Please login again'
		localStorage.removeItem("accessToken")
		history.push(ENTRY_ROUTE)
		window.location.reload();
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}
	
	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	if (error.response.status === 400) {
		if ("message" in error.response.data)
			notificationParam.message = error.response.data.message
	}

	if (error.response.status === 422) {
		// if ("errors" in error.response.data)
		// 	notificationParam.message = Utils.renderCollectionNotificationError(error.response.data.errors);
	}

	return Promise.reject(error);
});

export default service